function preventDefault(e) {
    e.preventDefault();
}
var dom = {
    preventDefault: preventDefault,
};

export { dom };
